<ng-container *transloco="let t;">
  <div class="p-grid">
    <div class="p-col-6">
      <h2>{{ t('common.labels.elements') }}</h2>
    </div>
    <div class="p-col-6 p-text-right" *ngIf="inOrdering !== true">
      <button withRight="admin.element.create" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
      <button *ngIf="exercise?.elements?.length > 1" withRight="admin.element.edit" pButton (click)="onStartOrdering()" type="button" label="{{ t('common.labels.sequence') }}" icon="pi pi-list" class="p-button-sm p-button-outlined p-mb-2 p-ml-2"></button>
    </div>
    <div class="p-col-6 p-text-right" *ngIf="inOrdering === true">
      <form (submit)="onSubmit()" novalidate *ngIf="exercise !== null">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </form>
    </div>
  </div>

  <app-element-list
    [exercise]="exercise"
    [inOrdering]="inOrdering"
    (exerciseChange)="exerciseChanged($event)"
    (rowReorder)="onRowReorder($event)"
  ></app-element-list>

  <app-inherit-dialog
  [title]="t('common.labels.save')"
  [mode]="'exercise'"
  [(visible)]="inheritVisible"
  (okClicked)="saveOrder($event)"
></app-inherit-dialog>

</ng-container>
